import { actionTypes } from '../actions/meta'


const initial = {
  page: 1,
  total_results: 0,
  total_pages: 1,
  page_lenght: 40,
  next_page: '',
  prev_page: '',
  to: 1,
  from: 40,
  order_by: 'max_price'
}

// menu reducers
export default (state = initial, action) => {
  switch (action.type) {

    case actionTypes.PAGE_NEXT:
      return Object.assign({}, state, {
        page: state.page + 1
      })

    case actionTypes.PAGE_PREV:
      return Object.assign({}, state, {
        page: state.page - 1
      })

    case actionTypes.SET_CANT_ELEMENTS:
      return Object.assign({}, state, {
        page_lenght: action.value
      })

    case actionTypes.SET_LIST_DATA:
      let data = action.data
      return Object.assign({}, state, {
        page_lenght: data.per_page,
        page: data.current_page,
        total_results: data.total,
        total_pages: data.last_page,
        next_page: data.next_page_url,
        prev_page: data.prev_page_url,
        to: data.to,
        from: data.from
      })

    case actionTypes.SET_ORDER:
      return Object.assign({}, state, {
        order_by: action.value
      })

    case actionTypes.CHANGE_PAGE:
      return Object.assign({}, state, {
        page: action.value
      })

    case actionTypes.RESET_INITIAL_PAGE:
      return Object.assign({}, state, {
        page: initial.page,
        to: initial.to,
        from: initial.from,
        page_lenght: initial.page_lenght,
      })

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/meta.js